import React, { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const ToggleMenuItem = ({ children, isActive }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isActive
          ? theme.custom.background1
          : theme.custom.background3,
        padding: '6px',
        paddingHorizontal: '8px',
        borderRadius: '6px',
        minWidth: 120,
      }}
    >
      <Typography
        sx={{
          color: isActive ? theme.custom.primary : theme.custom.textLight,
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

const ToggleMenu = ({
  leftTitle = 'People',
  rightTitle = 'Team',
  onRightClick,
  onLeftClick,
  initialActive = 'left',
}) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(
    initialActive === 'left' ? leftTitle : rightTitle
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        padding: '3px',
        backgroundColor: theme.custom.background3,
        borderRadius: '6px',
      }}
    >
      <Box
        sx={{ cursor: 'pointer', marginRight: '8px' }}
        onClick={() => {
          onLeftClick?.();
          setActiveTab(leftTitle);
        }}
      >
        <ToggleMenuItem isActive={activeTab === leftTitle}>
          {leftTitle}
        </ToggleMenuItem>
      </Box>
      <Box
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          onRightClick?.();
          setActiveTab(rightTitle);
        }}
      >
        <ToggleMenuItem isActive={activeTab === rightTitle}>
          {rightTitle}
        </ToggleMenuItem>
      </Box>
    </Box>
  );
};

export default ToggleMenu;
